import * as React from 'react';
import AvatarEditor from 'react-avatar-editor';

import Button from 'components/Button';
import Dialog from 'components/Dialog';
import Slider from 'components/Slider';
import { uploadFile } from 'lib/fileUploadHelper';

import './styles/AvatarEditorModal.scss';

const DIAMETER_PIXELS = 350;
const TRANSPARENT_WHITE_COLOR = [255, 255, 255, 0.5];
const INITIAL_SCALE = 1.2;

type Props = {
  image: string;
  fileContextKey: string;
  filename: string;
  onSuccess: () => void;
  uploadRequest: (ctx: string, name: string, blob: File, onSuccess: () => void) => void;
  loadThumbnail: (fileContextKey: string, filename: string, thumbnail: string) => void;
  onRequestHide?: () => void;
};

type State = {
  scale: number;
};

class AvatarEditorModal extends React.Component<Props, State> {
  state: State = {
    scale: INITIAL_SCALE,
  };
  _editor: AvatarEditor | null = null;

  uploadRequestWithCallbacks = (ctx: string, name: string, blob: File) => {
    this.props.uploadRequest(ctx, name, blob, this.props.onSuccess);
  };

  handleUpload = (file: File) => {
    const { fileContextKey, onRequestHide, loadThumbnail } = this.props;
    uploadFile(fileContextKey, file, this.uploadRequestWithCallbacks, loadThumbnail);
    if (onRequestHide) {
      onRequestHide();
    }
  };

  uploadScaledImage = () => {
    const { filename } = this.props;

    if (!this._editor) {
      console.error('AvatarEditorModal allowed upload without editor');
      return;
    }

    const scaledCanvas: HTMLCanvasElement = this._editor.getImageScaledToCanvas();
    scaledCanvas.toBlob(blob => {
      (blob as any).name = filename; // add back the original name before uploading
      this.handleUpload(blob as File);
    });
  };

  updateImageScale = (value: number) => {
    this.setState({ scale: value });
  };

  render() {
    const { image, onRequestHide } = this.props;
    const { scale } = this.state;

    return (
      <Dialog
        className="AvatarEditorModal"
        eventScreenName="AvatarEditorModal"
        size="small"
        onRequestHide={onRequestHide}
        hideOnBlur={false}>
        <AvatarEditor
          ref={editor => (this._editor = editor)}
          image={image}
          width={DIAMETER_PIXELS}
          height={DIAMETER_PIXELS}
          borderRadius={DIAMETER_PIXELS / 2}
          color={TRANSPARENT_WHITE_COLOR}
          scale={scale}
          style={{ 'margin-top': ' 16px' }} // styles are passed to canvas element
        />
        <div className="AvatarEditorModal-controls">
          <Slider
            className="AvatarEditorModal-controls-slider"
            min={1}
            max={2.5}
            step={0.01}
            value={scale}
            onChange={this.updateImageScale}
            theme="light"
            size="thick"
          />
          <Button
            className="AvatarEditorModal-controls-saveButton"
            onClick={this.uploadScaledImage}>
            Save
          </Button>
        </div>
      </Dialog>
    );
  }
}

export default AvatarEditorModal;
